// Visibilidade de um item do menu lateral para o usuário atual.
//
// - `role: "admin"`: só admin do sistema.
// - `papeis`: papéis permitidos NA EMPRESA ATIVA (matriz de permissões da issue
//   #45); enquanto a empresa carrega o item é mantido, para evitar o flash de
//   menu vazio.
// Item sem `role`/`papeis` aparece para qualquer usuário logado.
export const menuVisivel = (item, { isAdmin, papel, empresaLoading }) => {
  if (item.role === "admin" && !isAdmin) {
    return false;
  }
  if (item.papeis && !empresaLoading && !item.papeis.includes(papel)) {
    return false;
  }
  return true;
};
